import React, { Component } from 'react';
import { withRouter} from "react-router-dom";
import GlobalControlLine from './components/GlobalControlLine/GlobalControlLineComponent';
import GlobalFieldLine from './components/GlobalFieldLine/GlobalFieldLineComponent';
import {DynamicDemoFormContext} from './DynamicDemoContext'
import DynamicDemoService from "app/services/dynamicDemo.service";
import GetErrorMessage  from 'app/helpers/error-message'
import {ShowError, ShowSuccess} from "app/components/toast"
import NewDynamicDemo from './models/DynamicDemoModel';
import Modal from 'app/components/Modal';
import cloneDeep from 'lodash/cloneDeep';
import isEqual from 'lodash/isEqual';
import ValidateDynamicDemo from './DynamicDemoValidation'

class DynamicDemoForm extends Component {    
    constructor(props){
        super(props);
        this.state = {            
            selectedDynamicDemo: NewDynamicDemo(),
            errors: []		
        }
    }

	componentWillReceiveProps(nextProps) {
		if (nextProps.selectedDynamicDemo != null) {
			this.setState({ selectedDynamicDemo: nextProps.selectedDynamicDemo });
		}	

        if (!isEqual(this.props.selectedDynamicDemo, nextProps.selectedDynamicDemo)) {
            this.setState({errors: []});            
        }
    }	

    updateSelectedDynamicDemo(newSelectedDynamicDemo) {
		this.setState({selectedDynamicDemo: newSelectedDynamicDemo})
    }

    addErrorMessage(field, message) {
        var errors = this.state.errors;
        errors.push({ field: field, errorMessage: message});
        this.setState({errors: errors})
    }	

    SaveDynamicDemo(dynamicDemo) {        
        this.props.toggleUiBlock(true);
        if (dynamicDemo.id) {
            DynamicDemoService.updateDynamicDemo(dynamicDemo)
                .then(response =>{                    
                    this.props.toggleUiBlock(false);
                    this.setState({successMessage: 'The dynamic demographic was saved successfully' });                    
					this.props.getDynamicDemoById(dynamicDemo.id);
                })
                .catch(error => {
					let errorMessage = GetErrorMessage(error);
					console.log("errorMessage on catch");
					console.log(errorMessage);
					this.props.toggleUiBlock(false);
					this.setState({ errorMessage: errorMessage});
                });
        }
        else {
            DynamicDemoService.createDynamicDemo(dynamicDemo)
                .then(response => {					
                    const newDynamicDemo = response.data;                    
                    this.props.toggleUiBlock(false);
                    this.setState({successMessage: 'The dynamic demographic was created successfully' });                                        
                    this.setState({selectedDynamicDemo: newDynamicDemo});					
					this.props.getDynamicDemoById(newDynamicDemo.id);
					
                })
                .catch(error => {
					let errorMessage = GetErrorMessage(error);
					console.log("errorMessage on catch");
					console.log(errorMessage);
					this.props.toggleUiBlock(false);
					this.setState({ errorMessage: errorMessage});
                });
        }

    }
    deleteDynamicDemo = event => {        
        this.setState({ deleteQuestionModalText: `Are you sure you want to delete the dynamic demographic settings for demographic '${this.state.selectedDynamicDemo.demoQuestionCode}'?`});
    }

    duplicateDynamicDemo = event => {        
        let cloned = cloneDeep(this.state.selectedDynamicDemo);
        cloned.id = null;
        cloned.demoQuestionCode = '';           
        cloned.dynamicDemoQuestion.questionId = null;
        cloned.dynamicDemoQuestion.demoQuestionCode = "";
        cloned.dynamicDemoQuestion.demoQuestionText = "";
        for (let index = 0; index < cloned.dynamicDemographicParams.length; index++) {
            cloned.dynamicDemographicParams[index].id = null;            
        }
		this.props.updateSelectedDynamicDemo(cloned);
    }

    confirmDelete() {        
        this.hideDeleteModal();
        this.props.toggleUiBlock(true);
        const dynamicDemoId = this.state.selectedDynamicDemo.id;
        DynamicDemoService.deleteDynamicDemo(this.state.selectedDynamicDemo)
        .then(response =>{            
            this.setState({successMessage: 'The dynamic demographic was deleted successfully' });            
            this.props.removeDeletedDynamicDemo(dynamicDemoId);
			setTimeout(() => {
				this.props.toggleUiBlock(false);
				this.props.closeEditor();				
			}, 2000);

            
        })
        .catch(error => {
            let errorMessage = GetErrorMessage(error);
            console.log("errorMessage on catch");
            console.log(errorMessage);
            this.props.toggleUiBlock(false);
            this.setState({ errorMessage: errorMessage});
        });
    }

    hideDeleteModal() {
        this.setState({deleteQuestionModalText: ''})
    }    

    handleSubmitAction = event => { 
		var validationErrors = ValidateDynamicDemo(this.state.selectedDynamicDemo);
		this.setState({errors: validationErrors});
		if (validationErrors && validationErrors.length === 0) {                    
			this.SaveDynamicDemo(this.state.selectedDynamicDemo);
		}        
        return;
    }

    render() {        
        return (
            <div className="AppFormComponent DynamicDemoForm">                 
                <DynamicDemoFormContext.Provider value={{updateSelectedDynamicDemo: this.updateSelectedDynamicDemo.bind(this), selectedDynamicDemo: this.state.selectedDynamicDemo}}>                
                    <form ref={ form => this.formEl = form } onSubmit={ this.handleSubmitAction }>
                        <GlobalControlLine errors={this.state.errors} 
                                handleSubmitAction={this.handleSubmitAction.bind(this)} 
                                deleteDynamicDemo={this.deleteDynamicDemo.bind(this)}
                                duplicateDynamicDemo={this.duplicateDynamicDemo.bind(this)}
                                closeEditorButtonOnClick={this.props.closeEditorButtonOnClick}
								didSelectedDynamicDemoChange={this.props.didSelectedDynamicDemoChange}								
								canChangeData={this.props.canChangeData}
								/>
                        <div className="form-head">
                            <GlobalFieldLine canChangeData={this.props.canChangeData} folders={this.props.folders} key={this.state.selectedDynamicDemo.id} metadata={this.props.metadata}/>
                        </div>                        
                    </form>                    
                </DynamicDemoFormContext.Provider>

                {this.state.errorMessage && ( <ShowError clearErrorMessage={() => this.setState({errorMessage: ''})} errorMessage={this.state.errorMessage} /> )}
                {this.state.successMessage && ( <ShowSuccess clearMessage={() => this.setState({successMessage: ''})} message={this.state.successMessage} /> )}
                {this.state.deleteQuestionModalText && ( <Modal content={this.state.deleteQuestionModalText} size="small" confirmModalHandler={this.confirmDelete.bind(this)} cancelModalHandler={this.hideDeleteModal.bind(this)} />)}				
            </div>            
        );
    }
}
export default withRouter(DynamicDemoForm); 